import { render, staticRenderFns } from "./BaseDialogLayout.vue?vue&type=template&id=7c05f4c6&scoped=true"
import script from "./BaseDialogLayout.vue?vue&type=script&lang=js"
export * from "./BaseDialogLayout.vue?vue&type=script&lang=js"
import style0 from "./BaseDialogLayout.vue?vue&type=style&index=0&id=7c05f4c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c05f4c6",
  null
  
)

export default component.exports